import styled from 'styled-components'

export const FormContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const DescriptionWrapper = styled.div`
  flex: 1;
`

export const QuantityWrapper = styled.div`
  width: 120px;

  @media (max-width: 768px) {
    width: 100%;
  }
`
